import React from "react";
import { useState, useEffect } from "react";

import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";

import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DocumentScannerOutlinedIcon from '@mui/icons-material/DocumentScannerOutlined';
import DoneOutlineRounded from "@mui/icons-material/DoneOutlineRounded";
import ClearIcon from "@mui/icons-material/Clear";

import Modal from "../../../components/Modal";

import TableFooter from "@mui/material/TableFooter";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import TablePagination from "@mui/material/TablePagination";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";

import api from "../../../service/api";
import Page from "../../../layout/Page";

const TableCellHead = styled(TableCell)(({ theme }) => ({
  color: "#3c4b64",
}));

const TablePaginationActions = (props) => {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
            <KeyboardArrowLeft />
          )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
            <KeyboardArrowRight />
          )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
};

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const CursosDisponibles = (props) => {     

      const [selected] = React.useState([]);
      const [page, setPage] = React.useState(0);
      const [rowsPerPage, setRowsPerPage] = React.useState(5);

      const breadcrumbs = [
        { nombre: "Inicio", ruta: "/" },
        { nombre: "Cursos disponibles", ruta: "" },
      ];
          
      const TabContainer = styled(Box)(({ theme }) => ({
        [theme.breakpoints.up("lg")]: {
          paddingRight: theme.spacing(10),
          paddingLeft: theme.spacing(10),
        },
      }));
      
      const Row = styled(Grid)(({ theme }) => ({
        marginBottom: theme.spacing(3),
      }));   

      const handleChangePage = (event, newPage) => {
        setPage(newPage);
      };
             
      const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
      };
        
      const [showInfo, setShowInfo] = useState(false);    
      const [showInscripcion, setShowInscripcion] = useState(false);
  
      const cerrarInfo = () => setShowInfo(false);
      
      const cerrarInscripcion = () => setShowInscripcion(false);

      const [submitting, setSubmitting] = useState(false);  
      
      const [datos, setDatos] = useState([]);
      const [detalle, setDetalle] = useState([]);
      const [estado, setEstado] = useState("");
      const [cursoId, setCursoId] = useState(0);
      const [mensaje, setMensaje] = useState("");
  
      const buscarCursosDisponibles = () => {       
        api
          .listaCursosDisponibles()
          .then((res) => {          
            setDatos(res.data); 
          })
          .catch((e) => {
            console.log("Error al cargar los datos");
          });
      };
  
      const buscarDetalleCurso = (id) => {
        let filtro = {
          id: id
        }
        api
          .mostrarDetalleCurso(filtro)
          .then((res) => {  
            setDetalle(res.data); 
          })
          .catch((e) => {
            console.log("Error al cargar los datos del curso seleccionado");
          });
      };  
       
      const mostrarModalInscribir = (curso) => {
          setEstado('');
          setCursoId(0);
          buscarDetalleCurso(curso.id_curso);
          setCursoId(curso.id_curso);
          setShowInscripcion(true);            
      }
  
      const mostrarModalInfo = (curso) => {
          setEstado('');
          buscarDetalleCurso(curso.id_curso);
          setShowInfo(true);
      }
        
      const guardarInscripcion = (id) => {

        let datos = {
          curso_id: id
        };
    
        api
          .inscribirACurso(datos)
          .then((res) => {            
            setEstado('S');
            setMensaje('Inscripción realizada correctamente');
            setTimeout(() => {
              setCursoId(0);
              setSubmitting(false);
              buscarCursosDisponibles();                  
              cerrarInscripcion();
            }, 2500); 
          })
          .catch((e) => {
            setEstado('N');
            setMensaje(e.response.data.error);
          });
    };
  
    useEffect(() => {
      buscarCursosDisponibles();
    }, []);    
         
   
    return ( 
        <Page breadcrumbs={breadcrumbs}>
        <TabContainer>
          <Row container spacing={1}>
              <Grid item xs={12} sm={12} sx={{ marginBottom: 0 }}>
                <Typography variant="titulo"><b>CURSOS DISPONIBLES</b></Typography>
              </Grid>
          </Row>
          <Row container spacing={1}>
            <Grid item xs={12} sm={12} sx={{ marginBottom: 0 }}>
              <Typography variant="cuerpo">
              A continuación se muestra el listado de cursos a los que podés inscribirte.
              </Typography>
            </Grid>
          </Row>

          <TableContainer>
          <Table
            aria-label="tabla cursos inscripto"
            sx={{ border: "1px solid #dee2e6" }}
            size="small"
          >
            <TableHead>
              <TableRow>
                <TableCellHead padding="normal">
                  <b>Curso</b>
                </TableCellHead>
                <TableCellHead padding="normal">
                  <b>Inicio cursado</b>
                </TableCellHead>
                <TableCellHead align="center" padding="normal">
                  <b>Modalidad</b>
                </TableCellHead>
                <TableCellHead align="center" padding="normal">
                  <b>Acciones</b>
                </TableCellHead>
              </TableRow>
            </TableHead>
            <TableBody>
              {datos.map((dato, index) => {
                return (
                  <TableRow
                    key={index}
                    sx={
                      index % 2 === 0
                        ? { backgroundColor: "#f2f2f2" }
                        : { backgroundColor: "#fff" }
                    }
                  >
                    <TableCell align="left" width="200">
                      {dato.nombre}
                    </TableCell>
                    <TableCell align="left" width="300">
                      {dato.fecha_inicio_cursado}
                    </TableCell>
                    <TableCell align="center" width="100">
                      {dato.modalidad}
                    </TableCell>
                    <TableCell align="center" width="200">
                      <>
                        <IconButton
                          title="Ver detalle del curso"
                          size="small"
                          onClick={() => mostrarModalInfo(dato)}
                        >
                          <DocumentScannerOutlinedIcon fontSize="small" />
                        </IconButton>

                        <IconButton
                          title="Inscribirme al curso"
                          size="small"
                          onClick={() => mostrarModalInscribir(dato)}
                        >
                          <EditOutlinedIcon fontSize="small" />
                        </IconButton>
                      </>
                    </TableCell>
                  </TableRow>
                );
              })}
              {datos.length === 0 ? (
                <TableRow>
                  <TableCell colSpan="6" align="center">
                    <Typography variant="aclaracion">
                      Sin cursos disponibles
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                  ""
                )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[
                    5,
                    10,
                    25,
                    { label: "Todos", value: datos.length },
                  ]}
                  count={datos.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  selected={selected}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>          
        </TableContainer>     
      </TabContainer>


      <Modal open={showInscripcion} handleClose={cerrarInscripcion}>        
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} sx={{ marginBottom: 1 }}>
              {detalle.map(cursoSeleccionado => (
                  <>
                  <Typography variant="titulo">¿Seguro/a de inscribirse al curso: <b>{cursoSeleccionado.nombre}</b>?</Typography>
                  </>
              ))}
            </Grid>
          </Grid>  
      
          <Grid container justifyContent="space-between" spacing={0}>
            <Grid item align="left">
                  {estado === "S" ? (
                      <Typography variant="cuerpo" sx={{color:'#799F4F'}}><b>{mensaje}</b></Typography>
                  ) : (
                      estado==="N"? (          
                        <Typography variant="cuerpo" sx={{color:'#bf2b11'}}><b>{mensaje}</b></Typography> 
                  ) : (                                
                      <Typography variant="cuerpo"></Typography>
                  ))
                  }   
            </Grid>
            <Grid
              item
              align="right"              
            >
              <Box align="right">  
              <Link key="Inicio" to="/">                    
                <Button
                  variant="plata"
                  onClick={cerrarInscripcion}
                  endIcon={<ClearIcon />}
                  sx={{ m: 1 }}
                >
                {"Cancelar"}
                </Button>
                </Link>
                <Button
                    sx={{ m: 1 }}
                    variant="verde"
                    color="primary"
                    type="button"                  
                    endIcon={<DoneOutlineRounded />}
                    onClick={() => guardarInscripcion(cursoId)}                  
                  >
                    {submitting ? "Inscribiendo..." : "Inscribirme"}
                  </Button>       
                </Box> 
            </Grid>                 
        </Grid>              
      </Modal>

      <Modal open={showInfo} handleClose={cerrarInfo}>        
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} sx={{ marginBottom: 1 }}>
              {detalle.map(cursoSeleccionado => (
                  <>
                  {cursoSeleccionado.nombre!=='' && cursoSeleccionado.nombre!==null?<Typography variant="titulo">Curso: <b>{cursoSeleccionado.nombre}</b></Typography>:''}
                  {cursoSeleccionado.fecha_inicio_cursado!=='' && cursoSeleccionado.fecha_inicio_cursado!==null?<><br></br><br></br><Typography variant="titulo">Inicio Cursado: <b>{cursoSeleccionado.fecha_inicio_cursado}</b></Typography></>:''}                  
                  {cursoSeleccionado.fecha_insc_inicio!=='' && cursoSeleccionado.fecha_insc_inicio!==null?<><br></br><br></br><Typography variant="titulo">Inicio Inscripción: <b>{cursoSeleccionado.fecha_insc_inicio}</b></Typography></>:''}                  
                  {cursoSeleccionado.nom_prof!=='' && cursoSeleccionado.nom_prof!==null?<><br></br><br></br><Typography variant="titulo">Docente: <b>{cursoSeleccionado.nom_prof}</b></Typography></>:''}                  
                  {cursoSeleccionado.modalidad!=='' && cursoSeleccionado.modalidad!==null?<><br></br><br></br><Typography variant="titulo">Modalidad: <b>{cursoSeleccionado.modalidad}</b></Typography></>:''}                
                  {cursoSeleccionado.descripcion_sede!=='' && cursoSeleccionado.descripcion_sede!==null?<><br></br><br></br><Typography variant="titulo">Sede: <b>{cursoSeleccionado.descripcion_sede}</b></Typography></>:''}                  
                  {cursoSeleccionado.descripcion!=='' && cursoSeleccionado.descripcion!==null?<><br></br><br></br><Typography variant="titulo">Presentación: <b>{cursoSeleccionado.descripcion.replace(/<[^>]*>?/g, '')}</b></Typography></>:''}                  
                  </>
              ))}
            </Grid>
          </Grid>  
      
          <Grid spacing={1}>           
            <Grid
              item
              align="right"              
            >                           
                <Button
                  variant="plata"
                  onClick={cerrarInfo}
                  endIcon={<ClearIcon />}
                  sx={{ m: 1 }}
                >
                {"Cerrar"}
              </Button>     
            </Grid>                 
        </Grid>              
      </Modal>
        
      </Page>
    );
}

export default CursosDisponibles;